
const digest = '546cc22ad905b5c4d7c272e47519b28c814bd4408863bb42b6c954013b9565f3';
const classes = {"wrapper":"_wrapper_8adrl_1","header":"_header_8adrl_6","items":"_items_8adrl_10","inline":"_inline_8adrl_15","title":"_title_8adrl_24","bold":"_bold_8adrl_28"};
const css = `._wrapper_8adrl_1 {
  display: flex;
  flex-direction: column;
  gap: 40px;
}
._wrapper_8adrl_1 ._header_8adrl_6 {
  display: flex;
  justify-content: flex-end;
}
._wrapper_8adrl_1 ._items_8adrl_10 {
  display: flex;
  flex-direction: row;
  gap: 10px;
}
._wrapper_8adrl_1 ._items_8adrl_10 ._inline_8adrl_15 {
  flex: 1;
}
._wrapper_8adrl_1 ._inline_8adrl_15 {
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
}
._wrapper_8adrl_1 ._title_8adrl_24 {
  font-size: 12px;
  color: #6f6f6f;
}
._wrapper_8adrl_1 ._bold_8adrl_28 {
  font-size: 14px;
  font-weight: 600;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  